import {WorldGameApi} from "@/api/backendService.js";

const BUNDLED_DEFAULTS = Object.values(
    import.meta.glob("@/assets/images/backgrounds/transitions/*.webp", {
        eager: true,
        query: "?url",
        import: "default",
    })
).sort();

/**
 * Supplies the ambient artwork shown while a character is in transit.
 *
 * The backend decides which set applies to the player's current position; this
 * only caches the answer per position so an overlay that opens twice in a row
 * does not re-hit the API, and falls back to the bundled art whenever the
 * campaign has configured nothing.
 */
class TransitionService {
    constructor(api) {
        this.api = api;
        this.cache = {};
    }

    get defaults() {
        return BUNDLED_DEFAULTS;
    }

    /**
     * Resolve the image URLs to show while travelling from the given position.
     * @param {string} positionId - Cache key; the API reads the position from the session.
     * @returns {Promise<string[]>} Image URLs, never empty.
     */
    async getImages(positionId) {
        const key = positionId || "unknown";
        if (this.cache[key]) {
            return this.cache[key];
        }

        let urls = [];
        try {
            const {data} = await this.api.worldTransitionImagesCurrentList();
            urls = (data || []).map((entry) => entry.image).filter(Boolean);
        } catch (error) {
            console.warn("Transition images unavailable, using bundled set", error);
        }

        if (!urls.length) {
            urls = this.defaults;
        }

        this.cache[key] = urls;
        return urls;
    }

    clearCache() {
        this.cache = {};
    }
}

export default new TransitionService(WorldGameApi);
export {TransitionService};
